import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { IContact } from '../../../../../type_definitions/datatypes';
import * as _ from 'underscore';
import { DashboardDataService } from '../../dashboard-data.service';
import { FormattingService } from '../../../services/formatting.service';
import { GaEventService } from '../../../services/ga-event.service';

@Component({
  selector: 'change-od-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class ChangeOdActionComponent extends BaseReportActionsDialog implements OnInit {
  private userIdField: IExtraFieldConfigurationObject;

  constructor(
    private formlyService: GaFormlyService,
    private dashboardDataService: DashboardDataService,
    private formattingService: FormattingService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    // create fields
    this.fields = this.createFields();

    // fill fields
    this.fillFields();
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    return [
      this.userIdField = this.formlyService.aSelect('userId', 'PSS')
        .isRequired()
        .withValueProp('id')
        .withLabelProp('name')
        .build()
    ];
  }

  private fillFields(): void {
    this.formlyService.fillField(
      this.userIdField,
      this.dashboardDataService.ODs()
        .then((users:IContact[]) => {
          return _.map(users, (user:IContact) => {
            return {
              id: user.id,
              name: this.formattingService.formatUsername(user)
            };
          });
        })
    );
  }
}